document.addEventListener("DOMContentLoaded", function () {
  // Get elements - with error handling
  const elements = {
    matchaSlider: document.getElementById("matcha-ratio-slider"),
    matchaValue: document.getElementById("matcha"),
    waterValue: document.getElementById("water"),
    milkValue: document.getElementById("milk"),
    resetButton: document.getElementById("reset-button"),
    sectionBackground: document.querySelector(".section-wrapper"),
    colorSwatch: document.getElementById("colorSwatch"),
    colorName: document.getElementById("colorName"),
    iWantContainer: document.querySelector(".i-want-container")
  };

  // Validate all elements exist
  const missingElements = Object.entries(elements)
    .filter(([_, element]) => !element)
    .map(([name]) => name);

  if (missingElements.length) {
    console.error(`Missing elements: ${missingElements.join(", ")}`);
    return; // Exit if elements are missing
  }

  const toggle = document.getElementById('temperatureToggle');
  const thumb = document.getElementById('toggleThumb');
  let isHot = false;

  // Matcha ratio mapping - sorted once at initialization

  // ICED matcha ratio mapping
  const icedMatchaRatios = [
    { matcha: 2, water: 40, milk: 90 },
    { matcha: 2.5, water: 45, milk: 90 },
    { matcha: 3, water: 50, milk: 100 },
    { matcha: 3.5, water: 50, milk: 110 },
    { matcha: 4, water: 55, milk: 110 },
  ];
  
  // HOT matcha ratio mapping (adjusted for hot preparation)
  const hotMatchaRatios = [
    { matcha: 2, water: 35, milk: 100 },
    { matcha: 2.5, water: 40, milk: 110 },
    { matcha: 3, water: 40, milk: 120 },
    { matcha: 3.5, water: 50, milk: 120 },
    { matcha: 4, water: 55, milk: 120 },
  ];

  // DEFAULTS (can be different for hot vs iced)
  const DEFAULTS = {
    iced: icedMatchaRatios[2],
    hot: hotMatchaRatios[2]
  };

  // Current defaults start with iced
  let currentDefaults = DEFAULTS.iced;

  // Color names based on matcha amount
  const COLOR_NAMES = {
    light: "LIGHT MATCHA",
    fresh: "FRESH MATCHA",
    golden: "THE GOLDEN RATIO",
    rich: "RICH MATCHA",
    bold: "BOLD MATCHA"
  };

  // Format initial values
  elements.matchaValue.textContent = currentDefaults.matcha;
  elements.waterValue.textContent = currentDefaults.water;
  elements.milkValue.textContent = currentDefaults.milk;

  // Initialize Pantone color based on initial slider value
  updatePantoneColor(parseFloat(elements.matchaSlider.value));

  // Update values when slider changes
  elements.matchaSlider.addEventListener("input", handleSliderChange);

  // Reset button
  elements.resetButton.addEventListener("click", resetToDefaults);
  
  function getBackgroundIndex(matchaAmount) {
    return matchaAmount === 2 ? 1 :
           matchaAmount === 2.5 ? 2 :
           matchaAmount === 3 ? 3 :
           matchaAmount === 3.5 ? 4 :
           matchaAmount === 4 ? 5 : 3;
  }

  /**
   * Updates background image class based on matcha amount
   * @param {number} matchaAmount - Current matcha amount
   */
  // Efficient background image update
  function updateBackgroundImageClass(matchaAmount) {
    // Use requestAnimationFrame for smoother updates
    requestAnimationFrame(() => {
      const sectionBackground = document.querySelector('.section-wrapper');
      
      // Remove all existing background classes efficiently
      sectionBackground.classList.remove(
        ...[1, 2, 3, 4, 5].map(num => `matcha-bg-${num}`)
      );
      
      if (!isHot) {
        const backgroundIndex = getBackgroundIndex(matchaAmount);
        sectionBackground.classList.add(`matcha-bg-${backgroundIndex}`);
      }
    });
  }

  // In the toggle event listener, update the background image class
  toggle.addEventListener('click', () => {
    isHot = !isHot;
    
    if (isHot) {
      toggle.classList.add('toggle-switch--active');
      thumb.textContent = 'HOT';
      // Remove all background classes when switching to hot mode
      ['matcha-bg-1', 'matcha-bg-2', 'matcha-bg-3', 'matcha-bg-4', 'matcha-bg-5'].forEach(className => {
        elements.sectionBackground.classList.remove(className);
      });
      // Change reset button color to hot color
      elements.resetButton.style.backgroundColor = 'var(--hot-color)';
      // Add a class to the slider for the hot state
      elements.matchaSlider.classList.add('hot-slider');
      // Change water label
      if (elements.waterLabel) {
        elements.waterLabel.textContent = "HOT WATER:";
      }
      // Update defaults to hot
      currentDefaults = DEFAULTS.hot;

      // Add hot-mode class to remove background image
      elements.sectionBackground.classList.add('hot-mode');
      elements.iWantContainer.classList.add('hot-mode');
    } else {
      toggle.classList.remove('toggle-switch--active');
      thumb.textContent = 'ICED';
      // Change reset button color back to cold color
      elements.resetButton.style.backgroundColor = 'var(--cold-color)';
      // Remove the hot-slider class
      elements.matchaSlider.classList.remove('hot-slider');
      // Change water label
      if (elements.waterLabel) {
        elements.waterLabel.textContent = "COLD WATER:";
      }
      // Update defaults to iced
      currentDefaults = DEFAULTS.iced;

      // Remove hot-mode class to restore background image
      elements.sectionBackground.classList.remove('hot-mode');
      elements.iWantContainer.classList.remove('hot-mode');
      // Restore background image class based on current slider value
      updateBackgroundImageClass(parseFloat(elements.matchaSlider.value));
    }
    // Update the values based on the current slider position and new temperature setting
    const matchaAmount = parseFloat(elements.matchaSlider.value);
    updateValues(matchaAmount);
  });
 

  /**
   * Updates all values based on matcha amount and current temperature
   * @param {number} matchaAmount - Current matcha amount
   */
  function updateValues(matchaAmount) {
    const ratio = getMatchaRatio(matchaAmount);
    
    // Update recipe values
    elements.matchaValue.textContent = matchaAmount.toFixed(1);
    elements.waterValue.textContent = ratio.water;
    elements.milkValue.textContent = ratio.milk;
    
    // Toggle reset button visibility based on if we're at the current default
    updateResetButtonVisibility(matchaAmount);
    
    // Update Pantone color
    updatePantoneColor(matchaAmount);
    
    // Update background image class
    updateBackgroundImageClass(matchaAmount);
    
  }
  /**
   * Handles slider change events
   */
  function handleSliderChange() {
    const matchaAmount = parseFloat(this.value);
    updateValues(matchaAmount);
    // Update background image class
    updateBackgroundImageClass(matchaAmount);

  }

  /**
   * Updates reset button visibility based on current matcha amount
   * @param {number} matchaAmount - Current matcha amount
   */
  function updateResetButtonVisibility(matchaAmount) {
    elements.resetButton.style.visibility =
      matchaAmount === currentDefaults.matcha ? "hidden" : "visible";
  }

  /**
   * Resets all values to defaults based on current temperature
   */
  function resetToDefaults() {
    elements.matchaSlider.value = currentDefaults.matcha;
    elements.matchaValue.textContent = currentDefaults.matcha.toFixed(1);
    elements.waterValue.textContent = currentDefaults.water;
    elements.milkValue.textContent = currentDefaults.milk;
    elements.resetButton.style.visibility = "hidden";
    updatePantoneColor(currentDefaults.matcha);
  }

  /**
   * Gets matcha ratio from mapping with interpolation based on current temperature
   * @param {number} matchaAmount - Amount of matcha
   * @returns {Object} Object containing water and milk values
   */
  function getMatchaRatio(matchaAmount) {
    // Choose the appropriate ratio mapping based on temperature
    const matchaRatios = isHot ? hotMatchaRatios : icedMatchaRatios;
    
    // For exact matches
    const exactMatch = matchaRatios.find(
      (ratio) => ratio.matcha === matchaAmount
    );
    if (exactMatch) {
      return exactMatch;
    }

    // For values between defined points, interpolate
    for (let i = 0; i < matchaRatios.length - 1; i++) {
      if (
        matchaAmount > matchaRatios[i].matcha &&
        matchaAmount < matchaRatios[i + 1].matcha
      ) {
        const lowerRatio = matchaRatios[i];
        const upperRatio = matchaRatios[i + 1];
        const percentage =
          (matchaAmount - lowerRatio.matcha) /
          (upperRatio.matcha - lowerRatio.matcha);

        // Linear interpolation for water and milk
        return {
          water: Math.round(
            lowerRatio.water +
              percentage * (upperRatio.water - lowerRatio.water)
          ),
          milk: Math.round(
            lowerRatio.milk + percentage * (upperRatio.milk - lowerRatio.milk)
          ),
        };
      }
    }

    // If outside the range, use closest endpoint
    return matchaAmount < matchaRatios[0].matcha
      ? matchaRatios[0]
      : matchaRatios[matchaRatios.length - 1];
  }
  /**
   * Calculate RGB color based on matcha amount
   * @param {number} matchaAmount - Amount of matcha
   * @returns {string} RGB color string
   */
  function calculateMatchaColor(matchaAmount, min, max) {
    const ratio = (matchaAmount - min) / (max - min); // 0 to 1

    // Light green (more yellowish) to dark green
    const r = Math.round(150 - 100 * ratio);
    const g = Math.round(190 - 60 * ratio);
    const b = Math.round(90 - 70 * ratio);
    
    return `rgb(${r}, ${g}, ${b})`;
  }

  /**
   * Determines the color name based on matcha amount
   * @param {number} matchaAmount - Amount of matcha
   * @returns {string} Color name
   */
  function getColorName(matchaAmount) {
    switch(matchaAmount) {
      case 2:
        return COLOR_NAMES.light;
      case 2.5:
        return COLOR_NAMES.fresh;
      case 3:
        return COLOR_NAMES.golden;
      case 3.5:
        return COLOR_NAMES.rich;
      case 4:
        return COLOR_NAMES.bold;
    }
  }

  /**
   * Updates Pantone color display
   * @param {number} matchaAmount - Amount of matcha
   */
  function updatePantoneColor(matchaAmount) {
    const min = parseFloat(elements.matchaSlider.min);
    const max = parseFloat(elements.matchaSlider.max);

    // Calculate color
    const color = calculateMatchaColor(matchaAmount, min, max);

    // Update color display
    elements.colorSwatch.style.backgroundColor = color;
    elements.sectionBackground.style.backgroundColor = color;

    // Update color name
    elements.colorName.textContent = getColorName(matchaAmount);
  }
});
